import { SortUtil } from '@iot-platform/iot-platform-utils';
import { get } from 'lodash';
import { FilterCategoryV2, FilterConfigurationV2, FilterFieldV2 } from '../models';
import { COMMON_FILTERS_OPTIONS } from '../settings/filter-engine-v2.settings';
import { mapElementToFieldType } from './element-type-mapping.helper';
import { getDefaultOperator, getOperatorsForElement } from './operator-mapping.helper';

export function mergeAdditionalOptions(masterViewSettings: any, configurations: any[]): any[] {
  return configurations.reduce((acc: any[], item) => {
    let updatedOptions;
    if (item.root && !Array.isArray(item.options)) {
      const commonConfig = get(COMMON_FILTERS_OPTIONS, item.key, {});
      const filterConfig = get(masterViewSettings, [item.key], {});
      updatedOptions = {
        ...item.options,
        ...commonConfig,
        ...filterConfig
      };
    } else if (Array.isArray(item.options)) {
      updatedOptions = item.options.map((option: any) => {
        const commonConfig = get(COMMON_FILTERS_OPTIONS, option.key, {});
        const filterConfig = get(masterViewSettings, [item.key, option.key], {});
        return {
          ...option,
          options: {
            ...option.options,
            ...commonConfig,
            ...filterConfig
          }
        };
      });
    } else {
      updatedOptions = item.options;
    }
    acc.push({
      ...item,
      options: updatedOptions
    });
    return acc;
  }, []);
}

export function transformField(rawField: any, categoryLabel: string): FilterFieldV2 {
  const element = rawField.elementType as string;
  const operators = getOperatorsForElement(rawField);
  let defaultOperator = getDefaultOperator(element);
  if (rawField?.options?.defaultOperator && operators.includes(rawField?.options?.defaultOperator)) {
    defaultOperator = rawField?.options?.defaultOperator;
  }
  return {
    key: rawField.key,
    label: rawField.label,
    categoryName: categoryLabel,
    fullLabel: rawField.fullLabel || rawField.label,
    fieldType: mapElementToFieldType(element),
    order: rawField.order || 0,
    defaultFavorite: rawField.defaultFavorite || false,
    operators,
    defaultOperator,
    options: rawField.options
  };
}

export function transformFields(category: any): FilterFieldV2[] {
  const rawFields = category?.options || [];

  return rawFields
    .filter((field: any) => field !== null && field !== undefined)
    .map((field: any) => transformField(field, category?.label)).sort(SortUtil.sortByOrder);
}

export function transformCategory(rawCategory: any): FilterCategoryV2 {
  return {
    key: rawCategory?.key,
    label: rawCategory?.label,
    order: rawCategory?.order || 0,
    fields: transformFields(rawCategory)
  };
}

export function transformConfiguration(rawCategories: any[], masterViewSettings: any): FilterConfigurationV2 {
  let settings = [...rawCategories];

  settings = mergeAdditionalOptions(masterViewSettings, settings);

  const categories: (FilterFieldV2 | FilterCategoryV2)[] = settings
    .filter((item: any) => item !== null && item !== undefined)
    .map((item) => {
      if (item?.root && !Array.isArray(item.options)) {
        return transformField(item, item.label);
      }
      return transformCategory(item);
    })
    .sort(SortUtil.sortByOrder);

  return { categories };
}
